import pro1 from "../assets/w1.jpg";
import pro2 from "../assets/w2.jpg";
import pro3 from "../assets/w3.jpg";

const ProjectCardData = [
  {
    imgsrc: pro3,
    title: "Ads Management and Optimization",
    text: (
      <div>
        Discover our Ads Management service, perfect for businesses of
        all sizes. We create tailored ad campaigns, target the right audience,
        and craft compelling ad content. Our experts optimize your budget,
        conduct A/B testing, and track conversions. With dedicated account
        management and detailed reports, we ensure your campaigns deliver
        results. Stay ahead with the latest trends. Contact us to unleash the
        power of Meta advertising for your business!
      </div>
    ),
    view: "https://www.youtube.com/embed/tgbNymZ7vqY",
  },
  {
    imgsrc: pro2,
    title: "Front End & WordPress Website Development",
    text: (
      <div>
        Boost your online presence with our expertise in Front-End Development
        and WordPress. We create attractive, user-friendly websites using
        advanced tech like HTML, CSS, and JavaScript / frameworks like React or Laravel, and
        customize themes and plugins for WordPress. Whether you want a
        standalone Front-End solution or a WordPress-powered site, we tailor our
        services to fit your brand and goals. Elevate your digital presence and
        engage your audience effectively with our specialized services. Contact
        us today for a journey of digital success!
      </div>
    ),
    view: "https://www.youtube.com/embed/tgbNymZ7vqY",
  },
  {
    imgsrc: pro1,
    title: "Graphic Design",
    text: (
      <div>
        Enhance your brand's look with our Graphic Design services. We create
        eye-catching graphics like logos, 3D Designs, print materials, flyers, and web designs. Our
        team combines creativity with branding expertise to craft custom designs
        that match your brand's identity. Whether you need print materials,
        digital graphics, or web designs, we work closely with you to ensure
        they fit your brand. Whether you're a startup or an established
        business, our Graphic Design services can help you stand out. Contact us
        today to see how we can improve your brand's visual appeal!
      </div>
    ),
    view: "https://www.youtube.com/embed/tgbNymZ7vqY",
  },
];

export default ProjectCardData;
